@import '../../app-brand/entities/entity-layer.module.less';

.split-ship-modal {
  color: @split-ship-modal--text-color;
  font-size: 14px;
}

.body {
  padding: 16px;
}

.table-title {
  margin: 16px 0;
  font-size: 16px;
  line-height: 20px;
}

.instructions {
  font-size: 14px;
  line-height: 21px;
  margin: 0;
}

.footer {
  display: flex;
  align-items: center;
}

.action-button-container {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  gap: 8px;
  align-items: baseline;
}

.button {
  height: 32px;
  min-width: 112px;
}

.loading-indicator {
  position: static;
}

.hidden {
  visibility: hidden;
}

.error-banner {
  margin-bottom: 16px;
}
